module.exports = __webpack_public_path__ + "static/media/external_env_2_media_11.0760d8f9.webp";